const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel']
const LISTENER_OPTIONS = { passive: true, capture: true }
const IDLE_TIMEOUT = 10000
const WARMUP_ORIGINS = [
  'https://www.googletagmanager.com',
  'https://consent.cookiebot.com',
]

export default ({ $gtm }) => {
  if (!$gtm || typeof $gtm.init !== 'function') {
    return
  }

  let started = false

  const start = () => {
    if (started) {
      return
    }
    started = true
    INTERACTION_EVENTS.forEach(event =>
      window.removeEventListener(event, start, LISTENER_OPTIONS)
    )
    $gtm.init()
  }

  const warmUpConnections = () => {
    WARMUP_ORIGINS.forEach(origin => {
      const link = document.createElement('link')
      link.rel = 'preconnect'
      link.href = origin
      document.head.appendChild(link)
    })
  }

  const schedule = () => {
    warmUpConnections()
    INTERACTION_EVENTS.forEach(event =>
      window.addEventListener(event, start, LISTENER_OPTIONS)
    )
    window.setTimeout(start, IDLE_TIMEOUT)
  }

  if (document.readyState === 'complete') {
    schedule()
  } else {
    window.addEventListener('load', schedule, { once: true })
  }
}
